// extracted by mini-css-extract-plugin
module.exports = {"item":"style_item__mbvUJ","on":"style_on__3F07h"};